import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [

    {
        // 1
        label: 'Feeling nervous, anxious or on edge',
        field: 'gadNervous',
        type: 'select',
        answer: {
          type: 'single_select',
          options: [
            { key: '0', value: 'Not at all' },
            { key: '1', value: 'Several days' },
            { key: '2', value: 'More than half the days' },
            { key: '3', value: 'Nearly every day' },
          ]
        }
    },

    {
        // 2
        label: 'Not being able to stop or control worrying',
        field: 'gadControlWorying',
        type: 'select',
        answer: {
          type: 'single_select',
          options: [
            { key: '0', value: 'Not at all' },
            { key: '1', value: 'Several days' },
            { key: '2', value: 'More than half the days' },
            { key: '3', value: 'Nearly every day' },
          ]
        }
    },

    {
        // 3
        label: 'Worrying too much about different things',
        field: 'gadWorying',
        type: 'select',
        answer: {
          type: 'single_select',
          options: [
            { key: '0', value: 'Not at all' },
            { key: '1', value: 'Several days' },
            { key: '2', value: 'More than half the days' },
            { key: '3', value: 'Nearly every day' },
          ]
        }
    },

    {
        // 4
        label: 'Trouble relaxing',
        field: 'gadTroubleRelaxing',
        type: 'select',
        answer: {
          type: 'single_select',
          options: [
            { key: '0', value: 'Not at all' },
            { key: '1', value: 'Several days' },
            { key: '2', value: 'More than half the days' },
            { key: '3', value: 'Nearly every day' },
          ]
        }
    },
    
    {
        // 5
        label: 'Being so restless that it is hard to sit still',
        field: 'gadRestless',
        type: 'select',
        answer: {
          type: 'single_select',
          options: [
            { key: '0', value: 'Not at all' },
            { key: '1', value: 'Several days' },
            { key: '2', value: 'More than half the days' },
            { key: '3', value: 'Nearly every day' },
          ]
        }
    },

    {
        // 6
        label: 'Becoming easily annoyed or irritated',
        field: 'gadIrritated',
        type: 'select',
        answer: {
          type: 'single_select',
          options: [
            { key: '0', value: 'Not at all' },
            { key: '1', value: 'Several days' },
            { key: '2', value: 'More than half the days' },
            { key: '3', value: 'Nearly every day' },
          ]
        }
    },

    {
        // 7
        label: 'Feeling afraid as if something awful might happen',
        field: 'gadFeelingAfraid',
        type: 'select',
        answer: {
          type: 'single_select',
          options: [
            { key: '0', value: 'Not at all' },
            { key: '1', value: 'Several days' },
            { key: '2', value: 'More than half the days' },
            { key: '3', value: 'Nearly every day' },
          ]
        }
    },

    {
        // 8
        label: 'Your evaluated score',
        field: 'gadEvaluated',
        type: 'evaluated',
        answer: answers => {
          let score = 0;
          Object.keys(answers).map(key => {
            const answer = answers[key];
            if (Object.keys(answer).length === 1) {
              score += parseInt(Object.keys(answer)[0], 10);
            }
          });
          return score;
        }
      }
];

export default questionsModels;
